import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './authentication/components/login/login.component';
import {ToolbarComponent} from './shared/components/toolbar/toolbar.component';
import {AuthGuard} from './shared/components/guards/auth.guard';
import {ItemsComponent} from './items/items.component';
import {UsersComponent} from './users/users.component';
import {SuppliersComponent} from './suppliers/suppliers.component';
import {OrdersDashboardComponent} from './orders/orders-dashboard/orders-dashboard.component';
import {OrderDetailsComponent} from './orders/order-details/order-details.component';
import {OrderSummaryComponent} from './orders/order-summary/order-summary.component';
import {MultiRoleGuard} from './shared/components/guards/multi-role.guard';
import {BudgetInclusionComponent} from './orders/order-details/budget-inclusion/budget-inclusion.component';
import {KitsComponent} from './kits/kits.component';
import { LoginSuccessComponent } from './authentication/components/login-success/login-success.component';
import { DetailsKitComponent } from './kits/details-kit/details-kit.component';
import { NewOrderComponent } from './orders/new-order/new-order.component';

export const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  { path: 'login-success', component: LoginSuccessComponent },
  {
    path: '',
    component: ToolbarComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'items',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders']},
        component: ItemsComponent,
      },
      {
        path: 'items/:id',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders']},
        component: ItemsComponent,
      },
      {
        path: 'users',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin']},
        component: UsersComponent,
      },
      {
        path: 'suppliers',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders']},
        component: SuppliersComponent,
      },
      {
        path: 'orders-dashboard',
        canActivate: [AuthGuard],
        component: OrdersDashboardComponent,
      },
      {
        path: 'new-order',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: { allowedRoles: ['admin', 'approverOrders', 'requester'] },
        component: NewOrderComponent,
      },
      {
        path: 'new-order/confirm',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: { allowedRoles: ['admin', 'approverOrders', 'requester'] },
        component: OrderSummaryComponent,
      },
      {
        path: 'new-order/:id',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: { allowedRoles: ['admin', 'approverOrders', 'requester'] },
        component: NewOrderComponent,
      },
      {
        path: 'order-details/:id',
        canActivate: [AuthGuard],
        component: OrderDetailsComponent,
      },
      {
        path: 'budget-inclusion/:id',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders', 'approverBudgets' ]},
        component: BudgetInclusionComponent,
      },
      {
        path: 'kits',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders', 'approverBudgets' ]},
        component: KitsComponent,
      },
      {
        path: 'details-kit',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders', 'approverBudgets' ]},
        component: DetailsKitComponent,
      },
      {
        path: 'details-kit/:id',
        canActivate: [AuthGuard, MultiRoleGuard],
        data: {allowedRoles: ['admin', 'approverOrders', 'approverBudgets' ]},
        component: DetailsKitComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
